document.addEventListener("turbo:load", function() {
  // smooth scroll
  $('.js-anchor').on('click', function(event) {
    event.preventDefault();
    const target = $(this.getAttribute('href'));
    if (target.length) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top - 130
      }, 1000);
    }
  });

  // show back to-top-button only on deep scroll
  $(window).on('scroll', function(event) {
    $('#js-button-back-to-top').toggleClass('js-show-button-back-to-top', ($(window).scrollTop() > 600));
  });

 })
